import React, { useEffect, useState } from "react";
import styles from "./AffiliateWidget.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebook,
  faTwitter,
  faWhatsapp,
  faLinkedin,
} from "@fortawesome/free-brands-svg-icons";
import {
  faArrowUpRightFromSquare,
  faCopy,
  faLink,
} from "@fortawesome/free-solid-svg-icons";
import ClipBoard from "../../util/ClipBoard/ClipBoard";
import Swal from "sweetalert2";
import PrepaiTable from "../../common/prepaiTable";
import Footer from "../../common/userFooter";
import CopyToClipboard from "react-copy-to-clipboard";

// Helper to get correct referral URL based on props and userId
const getReferralUrl = (userId, isWebLink) => {
  if (!userId) return "";
  const baseUrl =
    isWebLink === 1 || isWebLink === "1"
      ? "https://www.prepai.io/?ref="
      : "https://app.prepai.io/register?ref=";
  return `${baseUrl}${userId}`;
};

const AffiliateWidget = ({ userData, is_web_link }) => {
  // On refresh, userData may be undefined/null until loaded, so we must handle that
  const [uniqueId, setUniqueId] = useState(userData || "");
  const [referralUrl, setReferralUrl] = useState(
    getReferralUrl(userData, is_web_link)
  );

  // Update uniqueId and referralUrl when userData or is_web_link changes
  useEffect(() => {
    console.log("userData", userData);
    console.log("is_web_link", is_web_link);
    setUniqueId(userData || "");
    setReferralUrl(getReferralUrl(userData, is_web_link));
  }, [userData, is_web_link]);

  const handleSocialIconClick = (socialSite) => {
    if (!referralUrl) return;
    switch (socialSite) {
      case "facebook":
        {
          const facebookURL = encodeURIComponent(referralUrl);
          window.open(
            `https://www.facebook.com/sharer/sharer.php?u=${facebookURL}`
          );
        }
        break;
      case "twitter":
        {
          const twitterURL = encodeURIComponent(referralUrl);
          window.open(`https://twitter.com/intent/tweet?url=${twitterURL}`);
        }
        break;
      case "linkedin":
        {
          const linkedinURL = encodeURIComponent(referralUrl);
          window.open(
            `https://www.linkedin.com/sharing/share-offsite/?url=${linkedinURL}`
          );
        }
        break;
      case "whatsapp":
        {
          const referralEncoded = encodeURIComponent(referralUrl);
          window.open(`https://api.whatsapp.com/send?text=${referralEncoded}`);
        }
        break;
      default:
        break;
    }
  };

  return (
    <>
      <div className={styles.container}>
        <div className={styles.fold1}>
          <div className={styles.textContainer}>
            <h1 style={{ fontSize: "58px !important" }}>
              Earn with Every Referral
            </h1>
            <p
              style={{
                fontSize: "28px !important",
                fontWeight: "400",
                color: "#888",
              }}
            >
              Leverage your network to earn while introducing others to the
              capabilities of PrepAI, an advanced AI assessment solution. Just
              enter your referral details and watch your commissions grow.{" "}
            </p>
          </div>
          <div className={""}>
            {" "}
            <img
              height={"420"}
              alt="fold-1-img"
              src="img/Earn_2520with_2520Every_2520referral3_2520_3_.jpg"
            />
          </div>
        </div>
        <div className={styles.foldmid} style={{ position: "relative" }}>
          <img
            height={"170"}
            width={"180"}
            alt="fold-1-img"
            style={{
              position: "relative",
              float: "left",
              top: "-6rem",
              left: "-2rem",
            }}
            src="img/greenarrow.png"
          />
          <div className={styles.copybox}>
            <h1>Copy and share your link</h1>
            <div className="d-flex" style={{ marginTop: "20px" }}>
              <input
                className={styles.copybox__input}
                disabled={true}
                value={referralUrl}
              />{" "}
              &nbsp;&nbsp;&nbsp;
              <CopyToClipboard
                text={referralUrl}
                onCopy={() =>
                  Swal.fire({
                    icon: "success",
                    title: "Link copied to clipboard!",
                    confirmButtonText: "Okay, got it",
                    confirmButtonColor: "#161A34",
                  })
                }
              >
                <button className={styles.copybox__btn}>
                  Copy Link &nbsp;
                  <FontAwesomeIcon icon={faCopy} />
                </button>
              </CopyToClipboard>
            </div>
            <br></br>
            <p className="d-flex align-items-center">
              Share the link on:{" "}
              <p className={styles.socialIcons}>
                <ul className={styles.listIcons}>
                  <li>
                    <FontAwesomeIcon
                      icon={faFacebook}
                      size="xl"
                      color="#43BEA1"
                      onClick={() => handleSocialIconClick("facebook")}
                    />
                  </li>
                  <li>
                    {" "}
                    <FontAwesomeIcon
                      icon={faTwitter}
                      size="xl"
                      color="#43BEA1"
                      onClick={() => handleSocialIconClick("twitter")}
                    />
                  </li>
                  <li>
                    <FontAwesomeIcon
                      icon={faLinkedin}
                      size="xl"
                      color="#43BEA1"
                      onClick={() => handleSocialIconClick("linkedin")}
                    />
                  </li>
                  <li>
                    <FontAwesomeIcon
                      icon={faWhatsapp}
                      size="xl"
                      color="#43BEA1"
                      onClick={() => handleSocialIconClick("whatsapp")}
                    />
                  </li>
                </ul>
              </p>
            </p>
          </div>
        </div>

        <div className={styles.fold2}>
          <div className={styles.textContainer2}>
            <h1>How do you get paid for your referrals?</h1>
            <p style={{ fontWeight: "400" }}>
              Based on our subscription plans, as well as lifetime plan, <br />{" "}
              our commission structure is designed to be straightforward yet
              rewarding. Here's how you can benefit from it.{" "}
            </p>
          </div>
          <div className={styles.commissionRates}>
            <div className={styles.header}>
              <span className={styles.emoji}>💰</span>
              <h2>Standard Commission Rates</h2>
            </div>

            <div className={styles.cardList}>
              <div className={styles.cardHeader}>
                <div>
                  <b>
                    No. of Licenses Sold
                    <br />
                    (Lifetime / Subscriptions)
                  </b>
                </div>
                <div>
                  <b>
                    Commission <br />
                    (On generated revenue)
                  </b>
                </div>
              </div>
              <div className={styles.card}>
                <div className={styles.cardLeft}>
                  <div>1-10</div>
                </div>
                <div className={styles.cardRight}>10%</div>
              </div>
              <div className={styles.card}>
                <div className={styles.cardLeft}>
                  <div>11-20</div>
                </div>
                <div className={styles.cardRight}>12%</div>
              </div>

              <div className={styles.card}>
                <div className={styles.cardLeft}>
                  <div>21-30</div>
                </div>
                <div className={styles.cardRight}>15%</div>
              </div>
              <div className={styles.card}>
                <div className={styles.cardLeft}>
                  <div>30+</div>
                </div>
                <div className={styles.cardRight}>20%</div>
              </div>
            </div>
          </div>
        </div>

        <br />
      </div>
      <Footer />
    </>
  );
};

export default AffiliateWidget;
